var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modalCambiarTodosCedis",attrs:{"titulo":"Cambiar valor en todos los Cedis de Forma Masiva","icon":"money","cargando":_vm.loading},on:{"guardar":_vm.aceptar}},_vm._l((_vm.distinMonedas),function(item){return _c('div',{key:item.id,staticClass:"row mx-0 justify-center"},[_c('monedasCambiar',{attrs:{"item":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }